import { render, staticRenderFns } from "./pallet.vue?vue&type=template&id=1f27fb4a&"
import script from "./pallet.vue?vue&type=script&lang=js&"
export * from "./pallet.vue?vue&type=script&lang=js&"
import style0 from "./pallet.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports